// ===== DetectNow: 수동 '지금 감지' (Phase 5, D09/D11) =====
// 방 멤버 누구나 채팅 헤더의 '지금 감지' 버튼으로 즉시 감지를 요청할 수 있다. 인가·범위 파생은
// 서버(ws-handler.ts detect-now 커맨드)가 전담하므로 클라이언트는 요청만 보내고, 응답 상태에
// 맞는 최소 피드백만 1회 토스트로 보여준다(CAP-N03: 상시 실패 표면 금지 — 반복 실패 뷰는 만들지
// 않는다). ws 콜백 등록은 ws-handlers.js(중앙 라우팅)를 거치지 않고 factory/init.ts 선례를 그대로
// 미러해 wsClient.callbacks에 직접 등록한다.

type DetectNowResultData = { status?: unknown; sessionId?: unknown };

const DETECT_NOW_STATUS_MESSAGES: Record<string, string> = {
  done: "감지를 완료했어요.",
  "no-op": "새 메시지가 없어요.",
  queued: "실행 중인 대화가 끝나면 감지할게요.",
  running: "이미 감지가 진행 중이에요.",
  failed: "감지에 실패했어요. 잠시 후 다시 시도해 주세요.",
  denied: "이 방의 멤버만 감지를 요청할 수 있어요.",
};

function requestDetectNow(): void {
  if (!wsClient || !wsClient.isConnected) return;
  wsClient.send("detect-now", {});
}

function onDetectNowResult(data: DetectNowResultData): void {
  const status = typeof data.status === "string" ? data.status : "";
  const message = DETECT_NOW_STATUS_MESSAGES[status] || "요청을 처리했어요.";
  if (typeof showSummaryToast === "function") showSummaryToast(message, true);
}

function _registerDetectNowWsHandler(): void {
  if (typeof wsClient === "undefined" || !wsClient?.callbacks) return;
  wsClient.callbacks.onDetectNowResult = onDetectNowResult;
}

document.addEventListener("DOMContentLoaded", () => {
  _registerDetectNowWsHandler();
  const btn = document.getElementById("detectNowBtn");
  if (btn) btn.addEventListener("click", requestDetectNow);
});
